export enum RestaurantType {
    NONE = 'NONE',
    TYPE_1 = 'TYPE_1',
    TYPE_2 = 'TYPE_2',
    TYPE_3 = 'TYPE_3'
}
